import { EventEmitter } from '@angular/core';
import { environment } from "environments/environment";
import { HttpClient } from '@angular/common/http';
import { OriginEnum } from '@sc/pas-common';
import { Router } from '@angular/router';
import { HomeUrlHelper } from '@sc/pas-common';
import { DatePipe } from '../../../shared/pipes';
import { paymentRejectType } from '../components/constants/payment-reject-type';
import { MainSideBarService } from 'app/components/shared/main-side-bar/main-side-bar.service';
import { AnalyticsService } from '@sc/pas-common';
import { saveAs } from 'file-saver';
import { map, tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
import * as i3 from "../../../shared/pipes/date.pipe";
import * as i4 from "../../../components/shared/main-side-bar/main-side-bar.service";
import * as i5 from "../../../../../../../libs/pas-common/src/lib/services/analytics.service";
import * as i6 from "../../../../../../../libs/pas-common/src/lib/helpers/home-url.helper";
var RejectionSearchService = /** @class */ (function () {
    function RejectionSearchService(httpClient, router, datePipe, mainSideBarService, analyticsService, urlHelper) {
        this.httpClient = httpClient;
        this.router = router;
        this.datePipe = datePipe;
        this.mainSideBarService = mainSideBarService;
        this.analyticsService = analyticsService;
        this.urlHelper = urlHelper;
        this.shareToInsuredResponse = [];
        this.isOpen = new EventEmitter();
        this.showAlertMessage = true;
    }
    RejectionSearchService.prototype.doSearch = function (request) {
        return this.httpClient.post(environment.server.api.portalpas + "/Payments/rejected-list", request);
    };
    RejectionSearchService.prototype.getPrimaryInsured = function (policyNumber) {
        return this.httpClient.get(environment.server.api.portalpas + "/Policy/primary-insured?policyNumber=" + policyNumber);
    };
    RejectionSearchService.prototype.addRejectShare = function (rejectShareRequest) {
        return this.httpClient.post(environment.server.api.portalpas + "/Payments/rejected-action", rejectShareRequest);
    };
    RejectionSearchService.prototype.shareToInsured = function (rejectShareRequest) {
        var _this = this;
        return this.httpClient.post(environment.server.api.portalpas + "/Payments/share-to-insured", rejectShareRequest).pipe(tap(function (response) {
            response.couponNumber = rejectShareRequest.couponNumber;
            _this.shareToInsuredResponse.push(response);
        }));
    };
    RejectionSearchService.prototype.exportExcel = function (fileStartName, request) {
        var filename = fileStartName + "-" + new Date().toISOString().slice(0, 10).replace(/-/g, '') + ".xlsx";
        return this.httpClient.post(environment.server.api.portalpas + "/Payments/export", request, { responseType: 'blob' }).pipe(map(function (response) {
            saveAs(response, filename);
        }));
    };
    RejectionSearchService.prototype.sendMail = function (request) {
        return this.httpClient.post(environment.server.api.portalpas + "/Mailing/send-mail-rejection", request);
    };
    RejectionSearchService.prototype.tryNewVersion = function () {
        var _this = this;
        return this.httpClient.post(environment.server.api.portalpas + "/featuretoggle/rejections", {}).subscribe(function () {
            var url = 'polizas/rechazos';
            _this.mainSideBarService.forceMenuReload(url);
            _this.router.navigate([url]);
        });
    };
    RejectionSearchService.prototype.returnToOldVersion = function (user, reason) {
        var _this = this;
        var data = {
            message: reason,
            dateTime: new Date().toISOString(),
            userId: user.UserId,
            userName: user.userName
        };
        this.analyticsService.AppInsights.event('volver_rechazos_legado', data);
        return this.httpClient.delete(environment.server.api.portalpas + "/featuretoggle/rejections").subscribe(function () {
            var url = 'mi-cuenta/rechazos';
            _this.mainSideBarService.forceMenuReload(url);
            _this.router.navigate([url]);
        });
    };
    RejectionSearchService.prototype.openPolicyDetails = function (policyNumber) {
        if (policyNumber.substring(6, 8) === '06' || (policyNumber.substring(6, 8) === '01')) {
            window.open("/detalle-poliza/ver/" + policyNumber + "/" + OriginEnum.rejectionList, '_blank');
            return;
        }
        else {
            var url = this.urlHelper.urlByOrigin("/PortalSCNet/PortalPas/AccesoAPortalPas.aspx?Destino=PolizaIndividual&casa=" + policyNumber.split('-')[1] + "&ramo=" + policyNumber.split('-')[2] + "&polizaNro=" + policyNumber.split('-')[3], 'LEGACY_BASE');
            this.urlHelper.addTokenUrlItem(url, 'NUEVO_PORTAL_TOKEN').subscribe(function (responseUrl) {
                window.open(responseUrl, '_blank', 'toolbar=0,location=0,menubar=0');
            });
        }
    };
    RejectionSearchService.prototype.getPrimaryRejectedPaymentEvents = function (listRejectedPaymentEvent) {
        var response = '';
        if (listRejectedPaymentEvent.length > 0) {
            listRejectedPaymentEvent.sort(function (a, b) { return b.attempt - a.attempt; });
            var rejectedPaymentEvent = listRejectedPaymentEvent[0];
            response = paymentRejectType.get(rejectedPaymentEvent.paymentRequestRejectType.description) + ": " + this.datePipe.transform(rejectedPaymentEvent.rejectDate);
        }
        return response;
    };
    RejectionSearchService.prototype.getPrimaryRejectedPaymentType = function (listRejectedPaymentEvent) {
        var response = '';
        if (listRejectedPaymentEvent.length > 0) {
            listRejectedPaymentEvent.sort(function (a, b) { return b.attempt - a.attempt; });
            var rejectedPaymentEvent = listRejectedPaymentEvent[0];
            response = paymentRejectType.get(rejectedPaymentEvent.paymentRequestRejectType.code);
        }
        return response;
    };
    RejectionSearchService.prototype.getSecondaryRejectedPaymentEvents = function (listRejectedPaymentEvent) {
        var response = '';
        if (listRejectedPaymentEvent.length > 1) {
            listRejectedPaymentEvent.sort(function (a, b) { return a.attempt - b.attempt; });
            var rejectedPaymentEvent = listRejectedPaymentEvent[0];
            if (rejectedPaymentEvent.paymentRequestRejectType) {
                if (rejectedPaymentEvent.rejectDate) {
                    response = paymentRejectType.get(rejectedPaymentEvent.paymentRequestRejectType.description) + ": " + this.datePipe.transform(rejectedPaymentEvent.rejectDate);
                }
                else {
                    response = 'Próximo intento programado';
                }
            }
        }
        return response;
    };
    RejectionSearchService.prototype.getData = function (couponNumber) {
        return this.shareToInsuredResponse.find(function (element) { return element.couponNumber === couponNumber; });
    };
    RejectionSearchService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RejectionSearchService_Factory() { return new RejectionSearchService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.DatePipe), i0.ɵɵinject(i4.MainSideBarService), i0.ɵɵinject(i5.AnalyticsService), i0.ɵɵinject(i6.HomeUrlHelper)); }, token: RejectionSearchService, providedIn: "root" });
    return RejectionSearchService;
}());
export { RejectionSearchService };
